import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'

import { getTranslations } from '../../utils'

const LoginHelp = () => {
    const {         
        password,
      } = getTranslations()
    return(
    <Grid container 
          justifyContent="space-between"
    >
        <Grid item xs>
            <Link 
                to="/auth/forgotpassword"
                component={RouterLink} 
                variant="body2"  
                color="#6415ff"
            >
                {password}
            </Link>
        </Grid>
        <Grid item xs>
            <Link 
                to="/auth/support"
                component={RouterLink} 
                variant="body2"  
                color="#6415ff"
            >
                Support
            </Link>
        </Grid>
        <Grid item>
            <Link 
                to="/auth/signup"
                component={RouterLink} 
                variant="body2"  
                color="#6415ff"
            >
                Signup
            </Link>
        </Grid>
    </Grid>
    )
}

export default LoginHelp